export default __webpack_public_path__ + "static/media/iconTextEvent.56ee2bcf.png";